// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import React from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
	Input,
	Select
} from "../../../_metronic/_partials/controls";

import { Button, Image } from 'react-bootstrap';
import { Editor } from '@tinymce/tinymce-react';

import { useIntl } from "react-intl";

export function EditForm({ saveItem, item, actionsLoading, onHide }) {

	const intl = useIntl();
    const [file, setFile] = React.useState(null)
    const fileHandler = (e) => {
        setFile(e.target.files[0])
    }

	return (
		<>
			<Formik
				enableReinitialize={true}
				initialValues={item}
				onSubmit={(values) => {
					saveItem(values);
				}}
			>
				{({ handleChange, handleSubmit }) => (
					<>
						<Modal.Body className="overlay overlay-block cursor-default">
							{actionsLoading && (
								<div className="overlay-layer bg-transparent">
									<div className="spinner spinner-lg spinner-success" />
								</div>
							)}
							<Form className="form form-label-right">
								<div className="form-group row">
									<label className="col-xl-3 col-lg-3 col-form-label">
										{ intl.formatMessage({ id: "Table.Store.Name" }) }
									</label>
									<div className="col-lg-9 col-xl-9">
										<Field
											name="name"
											component={Input}
											placeholder={ intl.formatMessage({ id: "Table.Store.Name" }) }
										/>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-xl-3 col-lg-3 col-form-label">
										{ intl.formatMessage({ id: "Table.Store.District" }) }
									</label>
									<div className="col">
										{ intl.formatMessage({ id: "Common.Chinese" }) }
										<Field
											name="district"
											component={Input}
											placeholder={ intl.formatMessage({ id: "Table.Store.District" }) }
										/>
									</div>
									<div className="col">
										{ intl.formatMessage({ id: "Common.English" }) }
										<Field
											name="district_eng"
											component={Input}
											placeholder={ intl.formatMessage({ id: "Table.Store.District" }) }
										/>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-xl-3 col-lg-3 col-form-label">
										{ intl.formatMessage({ id: "Table.Store.Address" }) }
									</label>
									<div className="col">
										{ intl.formatMessage({ id: "Common.Chinese" }) }
										<Field
											name="address"
											component={Input}
											placeholder={ intl.formatMessage({ id: "Table.Store.Address" }) }
										/>
									</div>
									<div className="col">
										{ intl.formatMessage({ id: "Common.English" }) }
										<Field
											name="address_eng"
											component={Input}
											placeholder={ intl.formatMessage({ id: "Table.Store.Address" }) }
										/>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-xl-3 col-lg-3 col-form-label">
										{ intl.formatMessage({ id: "Table.Store.Phone" }) }
									</label>
									<div className="col-lg-9 col-xl-9">
										<Field
											name="contact"
											component={Input}
											placeholder={ intl.formatMessage({ id: "Table.Store.Phone" }) }
										/>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-xl-3 col-lg-3 col-form-label">
										{ intl.formatMessage({ id: "Table.Store.Whatsapp" }) }
									</label>
									<div className="col-lg-9 col-xl-9">
										<Field
											name="whatsapp"
											component={Input}
											placeholder={ intl.formatMessage({ id: "Table.Store.Whatsapp" }) }
										/>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-xl-3 col-lg-3 col-form-label">
										{ intl.formatMessage({ id: "Table.Store.Latitude" }) }
									</label>
									<div className="col-lg-9 col-xl-9">
										<Field
											name="latitude"
											component={Input}
											placeholder={ intl.formatMessage({ id: "Table.Store.Latitude" }) }
										/>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-xl-3 col-lg-3 col-form-label">
										{ intl.formatMessage({ id: "Table.Store.Longitude" }) }
									</label>
									<div className="col-lg-9 col-xl-9">
										<Field
											name="longitude"
											component={Input}
											placeholder={ intl.formatMessage({ id: "Table.Store.Longitude" }) }
										/>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-xl-3 col-lg-3 col-form-label">
										{ intl.formatMessage({ id: "Table.Store.WorkingHour" }) } - { intl.formatMessage({ id: "Common.Chinese" }) }
									</label>
									<div className="col-lg-9 col-xl-9">
										<Field
											as={Editor}
											apiKey="jy9xmo0jvtxdivpgf49m1znn36njczcg4bz16ur5ogygoswa"
											name="working_hour"
											initialvalue={ item.working_hour }
											onEditorChange={(e) => {
												handleChange({ target: { name: 'working_hour', value: e } })
											}}
											init={{
												skin: "material-classic",
												height: 200,
												menubar: false,
												plugins: [
													'link wordcount emoticons'
												],
												toolbar:
												'undo redo | emoticons link formatselect  | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help'
											}}
										/>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-xl-3 col-lg-3 col-form-label">
										{ intl.formatMessage({ id: "Table.Store.WorkingHour" }) } - { intl.formatMessage({ id: "Common.English" }) }
									</label>
									<div className="col-lg-9 col-xl-9">
										<Field
											as={Editor}
											apiKey="jy9xmo0jvtxdivpgf49m1znn36njczcg4bz16ur5ogygoswa"
											name="working_hour_eng"
											initialvalue={ item.working_hour_eng }
											onEditorChange={(e) => {
												handleChange({ target: { name: 'working_hour_eng', value: e } })
											}}
											init={{
												skin: "material-classic",
												height: 200,
												menubar: false,
												plugins: [
													'link wordcount emoticons'
												],
												toolbar:
												'undo redo | emoticons link formatselect  | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help'
											}}
										/>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-xl-3 col-lg-3 col-form-label">
										{ intl.formatMessage({ id: "Table.Store.Status" }) }
									</label>
									<div className="col-lg-9 col-xl-9">
										<Select name="status">
											<option value="0">{ intl.formatMessage({ id: "Table.Store.Suspended" }) }</option>
											<option value="1">{ intl.formatMessage({ id: "Table.Store.Active" }) }</option>
										</Select>
									</div>
								</div>
							</Form>
						</Modal.Body>
						<Modal.Footer>
							<button
								type="button"
								onClick={onHide}
								className="btn btn-light btn-elevate"
							>
								{ intl.formatMessage({ id: "Table.Cancel" }) }
							</button>
							<> </>
							<button
								type="submit"
								onClick={() => handleSubmit()}
								className="btn btn-primary btn-elevate"
							>
								{ intl.formatMessage({ id: "Table.Save" }) }
							</button>
						</Modal.Footer>
					</>
				)}
			</Formik>
		</>
	);
}
